var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useState, useRef, useLayoutEffect, useEffect, } from "react";
import { StyledWrapper } from "./wrapper.styles";
// utils
import { makeDataTestIdGetter } from "../utils";
export const Wrapper = (_a) => {
    var { children, dataTestIdPrefix } = _a, props = __rest(_a, ["children", "dataTestIdPrefix"]);
    const [isLabelMultiLine, setIsLabelMultiLine] = useState(false);
    const labelRef = useRef(null);
    const getDataTestId = makeDataTestIdGetter(dataTestIdPrefix);
    function setLabelDimensions() {
        if (labelRef.current) {
            const { offsetHeight } = labelRef.current;
            setIsLabelMultiLine(offsetHeight > 44);
        }
    }
    useEffect(() => {
        window.addEventListener("resize", setLabelDimensions);
        return () => window.removeEventListener("resize", setLabelDimensions);
    }, []);
    useLayoutEffect(() => {
        setLabelDimensions();
    }, []);
    return (_jsx(StyledWrapper, Object.assign({ ref: labelRef }, props, { multiLine: isLabelMultiLine, "data-testid": getDataTestId("styled-wrapper") }, { children: _jsx(_Fragment, { children: children }) })));
};
